"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/jsx-max-depth */
const PlaceChooser_1 = __importDefault(require("@opsbase/web-data-choosers/PlaceChooser"));
const react_1 = __importDefault(require("react"));
const useOpScheduleCalendar_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendar"));
const useOpScheduleCalendarActions_1 = __importDefault(require("../OpScheduleCalendarController/useOpScheduleCalendarActions"));
function CalendarPlacePicker() {
    const { loading, places, allPlaces } = (0, useOpScheduleCalendar_1.default)();
    const { doChangeAllPlaces, doChangePlaces } = (0, useOpScheduleCalendarActions_1.default)();
    return (react_1.default.createElement(PlaceChooser_1.default, { multi: true, required: true, disabled: loading, value: places, onChange: doChangePlaces, allSelectable: true, allSelectedLabel: 'Any place', allSelected: allPlaces, onSelectAll: doChangeAllPlaces }));
}
exports.default = CalendarPlacePicker;
